<template>
  <div>
    <v-card
      style="background-color: transparent; border-radius: 15px"
      elevation="1"
    >
      <v-card-text>
        <v-container>
          <v-row
            dense
            class="mt-9"
            v-if="loading"
            alig="center"
            justify="center"
          >
            <v-progress-circular indeterminate></v-progress-circular>
          </v-row>
          <div v-else>
            <v-row dense justify="end" class="mb-2">
              <v-btn color="primary" @click="openIncluirAula">
                <v-icon left>mdi-plus</v-icon>
                Incluir aula
              </v-btn>
            </v-row>
            <v-row dense>
              <v-row dense class="mt-3">
                <v-row dense>
                  <AppCalendar
                    :items="events"
                    @adiar="adiar"
                    @reload="loadData"
                  />
                </v-row>
              </v-row>
            </v-row>
          </div>
          <IncluirAulaDialog
            ref="incluirAula"
            :groups="groups"
            :availability="availability"
            @created="loadData"
          />
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import AppCalendar from "@/components/calendar/calendar";
import IncluirAulaDialog from "@/components/calendar/incluirAulaDialog";
import partnerApi from "@/shared/pitchPartnerApi";

export default {
  name: "PartnerCalendar",
  components: { AppCalendar, IncluirAulaDialog },
  created() {
    this.loadData();
    this.loadComplementaryClassData();
  },
  data() {
    return {
      loading: true,
      events: [],
      groups: [],
      availability: [],
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      partnerApi.calendar().then((res) => {
        this.events = res.data.events;
        this.loading = false;
      });
    },
    loadComplementaryClassData() {
      partnerApi.getStudyGroups().then((res) => {
        this.groups = res.data || [];
      });
      partnerApi.showProfile().then((res) => {
        this.availability = res.data.aviability || [];
      });
    },
    openIncluirAula() {
      this.$refs.incluirAula.open();
    },
    adiar(item) {
      let request;
      const { action } = item;

      switch (action) {
        case "cancel": {
          if (
            window.confirm(
              "Confirmar cancelamento da aula? A mesma será considerada como não realizada."
            )
          ) {
            const { motivo } = item;
            request = partnerApi.cancelarAula(item.item.id, motivo);
          }
          break;
        }
        case "next": {
          if (window.confirm("Confirmar alteração do conteúdo da aula?")) {
            const { data } = item.item;
            request = partnerApi.adiarParaProxima(item.item.id, data);
          }
          break;
        }
        case "other": {
          request = partnerApi.postergate(item.item.id, item.item.data);
          break;
        }
        default:
          return;
      }
      request.then(() => {
        this.$root.$emit("display-alert", {
          text: "solicitação de alteração enviada! 😉",
          type: 0,
        });
        this.loadData();
      });
    },
  },
};
</script>
